import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import styles from './DownloadOptions.module.scss';
import { BrowserExtension } from '../BrowserExtension/BrowserExtension';
import { Software } from '../Software/Software';
import { useTranslation } from 'react-i18next';
import MyLibraryButton from '../../../../components/MyLibraryButton/MyLibraryButton';
import { useUIContext } from '../../../../context/UIContext';

const DownloadOptions = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);
  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView, setIsMobileView] = useState(mediaMatch.matches);
  const { miniSidebar } = useUIContext();

  const OPTIONS = {
    SOFTWARE: {
      name: 'download_center.software',
      children: <Software />,
    },
    BROWSER_EXTENSION: {
      name: 'download_center.browser_extension',
      children: <BrowserExtension />,
    },
  };

  const [options] = useState([OPTIONS.SOFTWARE, OPTIONS.BROWSER_EXTENSION]);

  const handleSelectTab = index => {
    setSelectedTab(index);
  };

  return (
    <div style={{ marginLeft: isMobileView ? '0px' : miniSidebar ? '80px' : '216px' }} className={cx(styles.mainContainer)}>
      <div className={styles.settingsContainer}>
        <div className={styles.settingsHeader}>
          <h1 className={styles.settingsTitle}>{t('download_center.title')}</h1>
        </div>
        <div className={styles.settingsTabs}>
          {!isMobileView &&
            options.map((el, index) => {
              return (
                <MyLibraryButton
                  key={el?.name}
                  className={cx(styles.tabButton, selectedTab === index && styles.activeTab)}
                  text={t(el?.name)}
                  onClick={() => handleSelectTab(index)}
                />
              );
            })}
        </div>
        <div>{options[selectedTab].children}</div>
      </div>
    </div>
  );
};

export default DownloadOptions;
